module.exports = __webpack_public_path__ + "img/Genesis-Martinez.838a5959.jpg";